
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 72 57"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.41 18.6a1 1 0 011-1h39.18a1 1 0 011 1v28.887a1 1 0 01-1 1H16.41a1 1 0 01-1-1V18.601z","fill":"#87B4F4"}}),_c('path',{attrs:{"d":"M3.97 55.541l3.432-8.58c0-1.715 56.624 0 57.768 0 1.144 0 4.576 8.58 4.576 9.724 0 .915-43.85-.381-65.776-1.144z","fill":"#FE5E4A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.385 22.177H64.82c.982 0 1.388-1.27.587-1.838-3.204-2.27-7.024-5.053-10.81-7.811C46.043 6.293 37.665.189 36.993.45 35.829.9 12.902 15.62 5.866 20.699c-.723.521-.372 1.478.52 1.478zM36.572 17.6a5.148 5.148 0 100-10.295 5.148 5.148 0 000 10.295z","fill":"#FE5E4A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.758 21.677h60.484v1H42.46c.092 3.906.198 9.35.23 13.975.016 2.415.012 4.61-.024 6.247a42.48 42.48 0 01-.081 2.008c-.018.252-.04.468-.065.637a2.397 2.397 0 01-.047.237.867.867 0 01-.105.253l-.272.42-.84-.544.25-.384a1.495 1.495 0 00.025-.133c.02-.131.04-.317.057-.558.035-.48.06-1.146.078-1.958.036-1.623.04-3.806.023-6.218a904 904 0 00-.229-13.982h-9.775v24.022h-1V22.677h-8.631v23.585h-1V22.677H5.758v-1z","fill":"#001C45"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.371 21.677v25.022h-1V21.677h1z","fill":"#001C45"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.334 46.271h51.333v1H10.333v-1zm-5.72 4.004h61.628v1H4.614v-1zM.038 54.85h71.924v1H.038v-1z","fill":"#001C45"}})])
          )
        }
      }
    